import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { isEmpty } from 'lodash';

import { icons } from '@tsq-web/assets';
import { TSqValidators } from '@tsq-web/forms';

import {
  getPasswordErrorMessage$,
  getPasswordRequirements$,
} from '../../../shared/password/utils/password-requirement';
import {
  RegistrationForm,
  RegistrationFormInitialValue,
  RegistrationFormValue,
} from '../../models/registration-form.model';

@Component({
  selector: 'comm-user-register-sign-up-form',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './sign-up-form.component.html',
})
export class SignUpFormComponent {
  @Input() isRegistering = false;
  @Input() isFetchingUser = false;

  @Output() signUp = new EventEmitter<RegistrationFormValue>();
  @Output() goBack = new EventEmitter<void>();

  protected readonly form = new FormGroup<RegistrationForm>({
    name: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
      Validators.pattern(/^\S*$/),
      TSqValidators.matchPasswordValidator('confirmPassword', true),
    ]),
    confirmPassword: new FormControl('', [TSqValidators.matchPasswordValidator('password')]),
  });
  protected readonly passwordRequirements$ = getPasswordRequirements$(this.form);
  protected readonly errorMessage$ = getPasswordErrorMessage$(this.passwordRequirements$);

  protected readonly icons = icons;
  protected readonly shimmersIterable = new Array(4);

  @Input() set initialData(value: RegistrationFormInitialValue) {
    if (isEmpty(value)) {
      return;
    }

    this.form.patchValue({ name: value.name, lastName: value.lastName });
  }

  onSubmit(): void {
    this.signUp.emit(this.form.value as RegistrationFormValue);
  }
}
